import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

async function cleanupLegacyServiceWorker(): Promise<boolean> {
  let hadActiveController = false;

  if ('serviceWorker' in navigator) {
    hadActiveController = Boolean(navigator.serviceWorker.controller);
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((registration) => registration.unregister()));
  }

  if ('caches' in window) {
    const cacheKeys = await window.caches.keys();
    await Promise.all(cacheKeys.map((cacheKey) => window.caches.delete(cacheKey)));
  }

  return hadActiveController;
}

function renderApp(): void {
  const rootElement = document.getElementById('root');
  if (!rootElement) {
    throw new Error('Could not find root element to mount to');
  }

  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

async function bootstrap(): Promise<void> {
  try {
    const hadActiveController = await cleanupLegacyServiceWorker();
    const reloadFlag = 'sw-legacy-cleanup-reload';

    // Um reload único garante que a página deixe de ser controlada pelo SW removido.
    if (hadActiveController && !sessionStorage.getItem(reloadFlag)) {
      sessionStorage.setItem(reloadFlag, '1');
      window.location.reload();
      return;
    }

    sessionStorage.removeItem(reloadFlag);
  } catch (error) {
    console.warn('[App] Falha ao limpar Service Worker legado:', error);
  }

  renderApp();
}

void bootstrap();
